/**
 * Utility functions for timer management
 */

import { TimerInstance } from './timerSystem';
import { MutableRefObject } from 'react';

interface TimerConfig {
  startTimestampRef: MutableRefObject<number | null>;
  timeRef: MutableRefObject<number>;
  onTimerUpdate?: (elapsed: number) => void;
}

/**
 * Creates a timer object with an update function for the shared system
 * @param config Timer configuration
 * @returns Timer object with update method
 */
export const createTimerObject = (config: TimerConfig): TimerInstance => ({
  update: (currentTime: number): number | null => {
    if (config.startTimestampRef.current) {
      const elapsed = currentTime - config.startTimestampRef.current + config.timeRef.current;
      if (config.onTimerUpdate) {
        config.onTimerUpdate(elapsed);
      }
      return elapsed;
    }
    return null;
  },
});
